import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=admin
  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => { setToken(null); setUser(false); };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}
